import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

import CanvasCreateForm from '../../containers/CanvasCreateForm';

class CanvasCreateBtn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  openModal = () => {
    // const { isModalOpen } = this.state;
    // console.log('CanvasCreateBtn: openModal: isModalOpen=', isModalOpen);
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    // const { isModalOpen } = this.state;
    // console.log('CanvasCreateBtn: closeModal: isModalOpen=', isModalOpen);
    this.setState({ isModalOpen: false });
  };

  toggleModal = () => {
    this.setState(state => ({
      isModalOpen: !state.isModalOpen,
    }));
  };

  handleAfterSubmit = () => {
    const { afterChange } = this.props;
    this.closeModal();
    afterChange();
  };

  renderModal() {
    const { gameSlug } = this.props;
    const { isModalOpen } = this.state;

    return (
      <Modal isOpen={isModalOpen} toggle={this.toggleModal}>
        <ModalHeader toggle={this.toggleModal}>
          <span>Create Canvas Course Runs</span>
        </ModalHeader>
        <ModalBody className="text-center">
          <CanvasCreateForm
            gameSlug={gameSlug}
            afterSubmit={this.handleAfterSubmit}
          />
        </ModalBody>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        <Button className="btn btn-bay-blue" onClick={this.openModal}>
          Create Canvas Course Runs
        </Button>
        {this.renderModal()}
      </div>
    );
  }
}

CanvasCreateBtn.propTypes = {
  gameSlug: PropTypes.string.isRequired,
  afterChange: PropTypes.func.isRequired,
};

export default CanvasCreateBtn;
